import { Component, Mixins } from 'vue-property-decorator';
import HybridMixin from '@rogues/shared/mixins/hybrid';
import { YRow, YCol } from '@components/index';
import CoreMixin from '@nodes/mixins/Core';
import { get } from 'lodash/object';
import { digits } from '@nodes/helpers/number';
import Props from './props';

@Component({
    components: {
        YRow,
        YCol,
    },
})

/**
 * @name Specs
 */
export default class Specs extends Mixins(HybridMixin, Props, CoreMixin) {
    localSpecs = this.getValue('specs')

    /**
     * Digits helper
     */
    digits = digits

    /**
     * Fetch Specs
     */
    fetchSpecs() {
        this.$wait.start('loading-specs');

        this.$services.Specs.valuesList({
            posts : [this.postId],
            locale: this.$i18n.locale,
        }).then((response: { data: { results: { items: { children: object[]; }[]; }; }; }) => {
            this.localSpecs = get(response.data.results, '0.items.0.children');
        }).catch((error: object) => {
            this.handleError(error);
        }).finally(() => {
            this.$wait.end('loading-specs');
        });
    }

    /**
     * @inheritdoc
     */
    created() {
        if (!this.getBoolean('specs') && this.getBoolean('postId')) {
            this.fetchSpecs();
        }
    }
}
